import React, { useState, useEffect, useMemo } from 'react';
import styles from './login.module.less';
import { Input, Button } from 'antd';
import { ArrowLeftOutlined, RedoOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { getResetPasswordVerificationCode } from '@Modules/account/profile/ProfileActions';
import { getCaptcha } from '@Modules/account/auth/AuthActions';
import qs from 'qs';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { history } from '@Redux/store';
import { detectFlavor } from '@Utils/FlavorUtils';

const ResetPassword = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  const { email } = useMemo(() => {
    return qs.parse(search, { ignoreQueryPrefix: true });
  }, [search]);

  const [captchaEnabled, setCaptchaEnabled] = useState(null);

  const [userEmail, setUserEmail] = useState(email ?? '');

  const [captchaCode, setCaptchaCode] = useState(null);

  const [isDisabled, setIsDisabled] = useState(true);

  const [token, setToken] = useState(null);

  const { resetPasswordLoading } = useSelector(
    (state) => state.account.profile
  );

  const resendCaptcha = () => {
    dispatch(getCaptcha(setToken, setCaptchaEnabled));
    setCaptchaCode(null);
  };

  useEffect(() => {
    resendCaptcha();
  }, []);

  useEffect(() => {
    const validateEmail = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    setIsDisabled(!userEmail || !validateEmail(userEmail));
  }, [userEmail]);

  const handleGetVerificationCode = () => {
    dispatch(
      getResetPasswordVerificationCode({
        body: {
          userEmail,
          captchaCode: captchaEnabled ? captchaCode?.trim() : null,
          captchaToken: captchaEnabled ? token : null,
        },
        cb: ({ email, otpId }) => {
          const params = qs.stringify(
            { email, otpId },
            { addQueryPrefix: true, encode: false }
          );

          history.push('/auth/reset-password-verify' + params);
        },
        resendCaptcha,
      })
    );
  };

  const handlePressEnter = (ev) => {
    if (ev.key === 'Enter') {
      ev.preventDefault();
      handleGetVerificationCode();
    }
  };

  const flavor = detectFlavor();

  return (
    <>
      <div className={styles[`home-page-${flavor}`]}>
        <div className={styles[`home-page__box-${flavor}`]}>
          <div
            className={`${styles['home-page__left-section']} ${
              styles[`home-page__left-section-${flavor}`]
            }`}
          >
            <div className={styles.form}>
              <div
                className={styles.form__back_button}
                onClick={() => history.push('/auth/login')}
              >
                <ArrowLeftOutlined />
                <span style={{ marginLeft: '8px' }}>Back</span>
              </div>
              <div className={styles.form__header}>Reset Password</div>
              <div className={styles.form__caption}>
                Enter your email please:
              </div>
              <div className={styles['form__item--last']}>
                <div className={styles.form__title}>Email</div>
                <Input
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  placeholder="Enter Email"
                  className={styles.form__input}
                />
              </div>

              <div
                className={styles['form__captcha-container']}
                style={{ display: captchaEnabled ? '' : 'none' }}
              >
                <div className={` ${styles.captchaContainer}`}>
                  <img
                    id="captcha-image"
                    alt="captcha"
                    style={{ borderRadius: '3px 0px 0px 3px' }}
                  />
                  <div onClick={resendCaptcha} className={styles.reCaptcha}>
                    <RedoOutlined />
                  </div>
                </div>

                <div>
                  <Input
                    id="int-login-captcha"
                    onKeyDown={(ev) => handlePressEnter(ev)}
                    value={captchaCode}
                    onChange={(e) => setCaptchaCode(e.target.value)}
                    placeholder="Enter Captcha Code"
                    className={styles.form__input}
                  />
                </div>
              </div>

              <div className={styles['form__button-container']}>
                <Button
                  loading={resetPasswordLoading}
                  onClick={handleGetVerificationCode}
                  type="primary"
                  className={styles.form__login}
                  disabled={isDisabled}
                  shape="round"
                  lassName={styles.form__login}
                >
                  SEND VERIFICATION CODE
                </Button>
              </div>
            </div>
          </div>
          <div
            id={`reset-side-${flavor}`}
            className={styles[`home-page__right-section-${flavor}`]}
          />
        </div>
      </div>
    </>
  );
};

export { ResetPassword };
